(ns frontend.view.reports.custom.events
  (:require [frontend.view.reports.custom.db :as db]
            [frontend.actions.reports :as reports]
            [frontend.logging :as logging]
            [frontend.state.current-session :as session]
            [cljs.reader :as edn]))

(defn load-deals-per-tag-status-and-stage []
  (reports/*->deals-per-tag-status-and-stage {:attribute (:tags-attribute @db/deals-per-tag-status-and-stage)
                                              :timestamp (:timestamp @db/deals-per-tag-status-and-stage)}
                                             (fn [response]
                                               (swap! db/deals-per-tag-status-and-stage assoc :report (:body response)))
                                             (fn [err]
                                               (logging/error "Error data : " err))))

(defn load-deals-throughput []
  (swap! db/deals-throughput assoc :loading true)
  (reports/*->deals-throughput {:start-ts (:start-ts @db/deals-throughput)
                                :end-ts   (:end-ts @db/deals-throughput)}
                               (fn [response]
                                 (let [job-id (:body response)]
                                   (session/wait-for-entity-attribute-value!
                                     job-id :job/status [:job.status/finished :job.status/error]
                                     (fn [_]
                                       (let [job (get @session/entities job-id)]
                                         (if (= (:job/status job) :job.status/finished)
                                           (swap! db/deals-throughput assoc :report (edn/read-string (:job/result job)))
                                           (swap! db/deals-throughput assoc :error (:job/result job)))
                                         (swap! db/deals-throughput dissoc :loading)
                                         )))))
                               (fn [err]
                                 (logging/error "Error deals throughput report : " err))))

(defn load-chop-data []
  (swap! db/chop assoc :loading true)
  (reports/*->deal-activities (fn [response]
                                (let [job-id (:body response)]
                                  (session/wait-for-entity-attribute-value!
                                    job-id :job/status [:job.status/finished :job.status/error]
                                    (fn [_]
                                      (let [job (get @session/entities job-id)]
                                        (if (= (:job/status job) :job.status/finished)
                                          (swap! db/chop assoc :report-data (edn/read-string (:job/result job)))
                                          (swap! db/chop assoc :error (:job/result job)))
                                        (swap! db/chop dissoc :loading)
                                        )))))
                              (fn [err]
                                (logging/error "Error loading CHOP deal activities report : " err))))
